import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5062/api';

const API = axios.create({
  baseURL: apiUrl,
});

// Hasta girişi yapanlar için otomatik token gönderimi
// girisTipi=1 ise localStorage'daki hastaToken'ı X-Hasta-Token header olarak ekle
API.interceptors.request.use(config => {
  const giristipi = localStorage.getItem('giristipi');
  if (giristipi === 'hasta') {
    const token = localStorage.getItem('hastaToken');
    if (token) config.headers['X-Hasta-Token'] = token;
  }
  return config;
});

export const getDoktorlar = () => API.get('/Auth/doktorlar');
export const girisYap = (dokKod, parola) => API.post('/Auth/giris', { dokKod, parola });
export const getBekleyenler = () => API.get('/Muayene/bekleyenler');
export const getHastalar = (ara) => API.get('/Hasta', { params: { ara } });
export const getHasta = (kayitNo) => API.get(`/Hasta/${kayitNo}`);
export const yeniHasta = (data) => API.post('/Hasta', data);
export const getHastaGelisleri = (kayitNo) => API.get(`/Muayene/hasta/${kayitNo}`);
export const getTemelMed = (kayitNo) => API.get(`/Hasta/${kayitNo}/temelmed`);
export const guncelleTemelMed = (kayitNo, degerler) => API.put(`/Hasta/${kayitNo}/temelmed`, degerler);
export const yeniMuayene = (data) => API.post('/Muayene', data);
export const getMuayene = (id) => API.get(`/Muayene/${id}`);
export const getKabulListesi = () => API.get('/Kabul');
export const getKabulAyrintiListesi = (masterProtNo) => API.get(`/Kabul/${masterProtNo}/ayrinti`);
export const kabulAyrintiEkle = (data) => API.post('/Kabul/ayrinti/ekle', data);
export const kabulAyrintiGuncelle = (data) => API.put('/Kabul/ayrinti/guncelle', data);
export const kabulYap = (data) => API.post('/Kabul/yeni', data);
export const getDoktorPersonel = () => API.get('/Doktor/personel');
export const getDoktorGonderen = () => API.get('/Doktor/gonderen');
export const getGelisTuruListesi = () => API.get('/GelisTuru');
export const ttbAra = (q) => API.get('/Ttb/ara', { params: { q } });
export const getTtbBaglilar = (kod) => API.get(`/Ttb/${kod}/baglilar`);
export const ttbStokAra = (q) => API.get('/TtbStok/ara', { params: { q } });
export const getTarifeListesi = () => API.get('/Tarife');
export const getTarife = (kod) => API.get(`/Tarife/${kod}`);
export const getPaketListesi = () => API.get('/Paket');
export const getPaketIcerik = (paketKod) => API.get(`/Paket/${paketKod}/icerik`);

export default API;

export const getAnamnezHemsListe = (kayitNo, masterProtNo) => API.get(`/AnamnezHems/hasta/${kayitNo}`, { params: { masterProtNo } });
export const getAnamnezHemsDetay = (id) => API.get(`/AnamnezHems/${id}`);
export const yeniAnamnezHems = (data) => API.post('/AnamnezHems', data);
export const guncelleAnamnezHems = (id, data) => API.put(`/AnamnezHems/${id}`, data);
export const silAnamnezHems = (id) => API.delete(`/AnamnezHems/${id}`);

export const getAnamnezDoktorListe = (kayitNo, masterProtNo) => API.get(`/AnamnezDoktor/hasta/${kayitNo}`, { params: { masterProtNo } });
export const getAnamnezDoktorDetay = (id) => API.get(`/AnamnezDoktor/${id}`);
export const yeniAnamnezDoktor = (data) => API.post('/AnamnezDoktor', data);
export const guncelleAnamnezDoktor = (id, data) => API.put(`/AnamnezDoktor/${id}`, data);
export const silAnamnezDoktor = (id) => API.delete(`/AnamnezDoktor/${id}`);

export const getDoktorOrderListe = (kayitNo, masterProtNo) => API.get(`/DoktorOrder/hasta/${kayitNo}`, { params: { masterProtNo } });
export const getDoktorOrderDetay = (id) => API.get(`/DoktorOrder/${id}`);
export const yeniDoktorOrder = (data) => API.post('/DoktorOrder', data);
export const guncelleDoktorOrder = (id, data) => API.put(`/DoktorOrder/${id}`, data);
export const silDoktorOrder = (id) => API.delete(`/DoktorOrder/${id}`);

export const getTaniListe = (kayitNo, masterProtNo) => API.get(`/Tani/hasta/${kayitNo}`, { params: { masterProtNo } });
export const silTani = (id) => API.delete(`/Tani/${id}`);
export const icd10Ara = (q) => API.get('/Tani/icd10ara', { params: { q } });
export const taniEkle = (data) => API.post('/Tani', data);

export const getDokumanListe = (kayitNo) => API.get(`/Proje/hasta/${kayitNo}`);
export const getDokumanUrl = (id) => `${apiUrl}/Proje/indir/${id}`;
export const dokumanYukle = (kayitNo, adSoy, dosya) => {
  const form = new FormData();
  form.append('kayitNo', kayitNo);
  form.append('adSoy', adSoy);
  form.append('dosya', dosya);
  return API.post('/Proje/yukle', form, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getBildirimListe = (kayitNo) => API.get(`/Bildirim/hasta/${kayitNo}`);
export const getBildirimKisiler = () => API.get('/Bildirim/kisiler');
export const bildirimGonder = (data) => API.post('/Bildirim/gonder', data);
export const tokenGiris = (token) => API.get(`/Bildirim/token-giris/${token}`);

// Görev modülü
export const getGorevlerim = (dokKod, params) => API.get(`/Bildirim/gorevlerim/${dokKod}`, { params });
export const gorevDurumGuncelle = (data) => API.post('/Bildirim/gorev-durum', data);